export function BlikkTextField({ header, value }) {
    return <div>
        <h3 className='mb-8'>{header}</h3>
        <p className='bg-primary py-6 px-12 rounded-4 mb-0'>{value}</p>
    </div>
}